import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import {
  fetchCategories, fetchDepartments,
  adminCreateCategory, adminUpdateCategory, adminDeleteCategory,
} from './api/issuesApi'

const empty = { cat_name: '', cat_icon: 'ri-tools-line', default_dept_id: '', cat_allow_dept_select: 0, cat_sort: 0, cat_active: 1 }

export default function IssueAdminCategories() {
  const [cats, setCats] = useState([])
  const [depts, setDepts] = useState([])
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [editingId, setEditingId] = useState(null)
  const [form, setForm] = useState(empty)

  const load = async () => {
    setLoading(true)
    try {
      const [c, d] = await Promise.all([fetchCategories('staff'), fetchDepartments('staff')])
      setCats(c); setDepts(d)
    } finally { setLoading(false) }
  }
  useEffect(() => { load() }, [])

  const startCreate = () => { setEditingId(null); setForm(empty); setShowForm(true) }
  const startEdit = (c) => {
    setEditingId(c.cat_id)
    setForm({
      cat_name: c.cat_name,
      cat_icon: c.cat_icon || 'ri-tools-line',
      default_dept_id: c.default_dept_id,
      cat_allow_dept_select: c.cat_allow_dept_select ? 1 : 0,
      cat_sort: c.cat_sort,
      cat_active: 1,
    })
    setShowForm(true)
  }

  const submit = async (e) => {
    e.preventDefault()
    if (!form.cat_name.trim() || !form.default_dept_id) {
      Swal.fire('กรุณากรอกข้อมูลให้ครบ', '', 'warning'); return
    }
    try {
      if (editingId) {
        await adminUpdateCategory(editingId, form)
      } else {
        await adminCreateCategory(form)
      }
      setShowForm(false)
      await load()
    } catch (err) {
      Swal.fire('ผิดพลาด', err.response?.data?.error || err.message, 'error')
    }
  }

  const del = async (c) => {
    const r = await Swal.fire({
      title: 'ลบ (ปิดการใช้งาน) ประเภทนี้?',
      text: c.cat_name, icon: 'warning',
      showCancelButton: true, confirmButtonText: 'ลบ', cancelButtonText: 'ยกเลิก',
    })
    if (!r.isConfirmed) return
    try { await adminDeleteCategory(c.cat_id); await load() }
    catch (err) { Swal.fire('ผิดพลาด', err.response?.data?.error || err.message, 'error') }
  }

  return (
    <div className="main main-app p-3 p-lg-4">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h4 className="mb-0"><i className="ri-list-settings-line me-2" />ประเภทปัญหา</h4>
        <button className="btn btn-primary" onClick={startCreate}>
          <i className="ri-add-line me-1" />เพิ่มประเภท
        </button>
      </div>

      {showForm && (
        <div className="card mb-3">
          <div className="card-body">
            <form onSubmit={submit}>
              <div className="row g-2">
                <div className="col-12 col-md-5">
                  <label className="form-label small">ชื่อประเภท</label>
                  <input className="form-control" value={form.cat_name}
                         onChange={e => setForm({ ...form, cat_name: e.target.value })} />
                </div>
                <div className="col-6 col-md-3">
                  <label className="form-label small">Icon (remixicon)</label>
                  <input className="form-control" value={form.cat_icon}
                         onChange={e => setForm({ ...form, cat_icon: e.target.value })} />
                </div>
                <div className="col-6 col-md-2">
                  <label className="form-label small">ลำดับ</label>
                  <input type="number" className="form-control" value={form.cat_sort}
                         onChange={e => setForm({ ...form, cat_sort: Number(e.target.value) || 0 })} />
                </div>
                <div className="col-12 col-md-2">
                  <label className="form-label small">ฝ่ายปลายทาง</label>
                  <select className="form-select" value={form.default_dept_id}
                          onChange={e => setForm({ ...form, default_dept_id: Number(e.target.value) })}>
                    <option value="">--</option>
                    {depts.map(d => <option key={d.dept_id} value={d.dept_id}>{d.dept_name}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-check mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="catAllowDeptSelect"
                  checked={!!form.cat_allow_dept_select}
                  onChange={e => setForm({ ...form, cat_allow_dept_select: e.target.checked ? 1 : 0 })}
                />
                <label className="form-check-label small" htmlFor="catAllowDeptSelect">
                  ให้ผู้แจ้งเลือกฝ่ายเอง (ไม่จำกัดฝ่ายปลายทาง) — ใช้ฝ่ายด้านบนเป็นค่าเริ่มต้น
                </label>
              </div>
              <div className="mt-3 d-flex gap-2">
                <button type="submit" className="btn btn-primary">บันทึก</button>
                <button type="button" className="btn btn-outline-secondary" onClick={() => setShowForm(false)}>ยกเลิก</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="card">
        <div className="table-responsive">
          {loading
            ? <div className="text-center py-5"><span className="spinner-border" /></div>
            : (
              <table className="table mb-0 align-middle">
                <thead className="table-light">
                  <tr>
                    <th>Icon</th>
                    <th>ชื่อ</th>
                    <th>ฝ่ายปลายทาง</th>
                    <th className="text-end">ลำดับ</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {cats.map(c => (
                    <tr key={c.cat_id}>
                      <td><i className={c.cat_icon} /></td>
                      <td>{c.cat_name}</td>
                      <td>
                        {c.cat_allow_dept_select
                          ? <span className="badge bg-info-subtle text-info">ผู้แจ้งเลือกฝ่ายเอง</span>
                          : c.default_dept_name}
                      </td>
                      <td className="text-end">{c.cat_sort}</td>
                      <td className="text-end">
                        <button className="btn btn-sm btn-outline-primary me-1" onClick={() => startEdit(c)}>
                          <i className="ri-edit-line" />
                        </button>
                        <button className="btn btn-sm btn-outline-danger" onClick={() => del(c)}>
                          <i className="ri-delete-bin-line" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          }
        </div>
      </div>
    </div>
  )
}
